import type { BoxWithLabel } from '@/type';

export type LabelingBoxOverlayFields = Pick<
  BoxWithLabel,
  'motionType' | 'velocityX' | 'velocityY' | 'yaw'
>;

export const pickLabelingBoxOverlayFields = (
  box: BoxWithLabel,
): LabelingBoxOverlayFields => ({
  motionType: box.motionType,
  velocityX: box.velocityX,
  velocityY: box.velocityY,
  yaw: box.yaw,
});
